var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.01355 12.4864L7.01352 12.4863C6.9496 12.4225 6.89889 12.3467 6.8643 12.2632C6.8297 12.1797 6.81189 12.0903 6.81189 11.9999C6.81189 11.9096 6.8297 11.8201 6.8643 11.7367C6.89889 11.6532 6.9496 11.5774 7.01352 11.5135L7.01355 11.5135L14.5135 4.0135C14.6426 3.88449 14.8175 3.81201 15 3.81201C15.1824 3.81201 15.3574 3.88449 15.4864 4.0135C15.6154 4.14251 15.6879 4.31748 15.6879 4.49993C15.6879 4.68238 15.6154 4.85735 15.4864 4.98636L8.5161 11.9557L8.4719 11.9999L8.5161 12.0441L15.4864 19.0135C15.5503 19.0774 15.601 19.1532 15.6355 19.2367C15.6701 19.3201 15.6879 19.4096 15.6879 19.4999C15.6879 19.5903 15.6701 19.6797 15.6355 19.7632C15.601 19.8466 15.5503 19.9225 15.4864 19.9864C15.4225 20.0502 15.3467 20.1009 15.2632 20.1355C15.1798 20.1701 15.0903 20.1878 15 20.1878C14.9096 20.1878 14.8202 20.1701 14.7367 20.1355C14.6533 20.1009 14.5774 20.0502 14.5135 19.9864L7.01355 12.4864Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.f27f39edcd05d59cb05db684c6b96d86.svg";
export { ForwardRef as ReactComponent };